export type LoaderKind = 'full-page' | 'inline';

const counts: Record<LoaderKind, number> = { 'full-page': 0, inline: 0 };
const listeners = new Set<() => void>();

const notify = () => {
  for (const listener of listeners) listener();
};

/**
 * Counts the loaders on screen per kind so route timing can measure how long
 * users look at a spinner. Components never depend on the timing code: it
 * subscribes here.
 */
export const loaderPresence = {
  mount(kind: LoaderKind) {
    counts[kind] += 1;
    notify();
    return () => {
      counts[kind] -= 1;
      notify();
    };
  },
  count: (kind: LoaderKind) => counts[kind],
  subscribe(listener: () => void) {
    listeners.add(listener);
    return () => {
      listeners.delete(listener);
    };
  },
};
